import React, { FC, useState } from 'react'
import { Button } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Divider } from '@material-ui/core'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'
import Notes from './Notes'
import CircleCheckbox from '../../../CircleCheckbox'
import EmailTemplatesModal from '../../../Modals/EmailTemplates'

interface MatchParams {
  email?: string
}

interface Props extends RouteComponentProps<MatchParams> {
  prospects?: ProspectsStore
}

const Actions: FC<Props> = ({ prospects, match, location, history }) => {
  const [openTemplateModal, setOpenTemplateModal] = useState(false)
  const [currentType, setCurrentType] = useState('')

  const handleCloseTemplateModal = (): void => {
    setOpenTemplateModal(false)
  }

  const handleToggleTemplateModal = (): void => {
    setOpenTemplateModal(prevOpen => !prevOpen)
  }

  const handleManeuverClick = (type: string): void => {
    setCurrentType(type)
    handleToggleTemplateModal()
  }

  if (prospects?.prospect) {
    return (
      <div className="actions">
        <div className="buttons">
          <Button variant="primary" block onClick={(): void => handleManeuverClick('Rev-Up')}>
            Rev-Up
          </Button>
          <Button variant="primary" block onClick={(): void => handleManeuverClick('Engaged')}>
            {' '}
            Engaged
          </Button>
          <Button variant="primary" block onClick={(): void => handleManeuverClick('Re-Engage')}>
            {' '}
            Re-Engage
          </Button>
        </div>

        <div className="switches">
          <CircleCheckbox
            name={
              prospects?.sendProspectChecked
                ? prospects?.sendProspectCheckedText
                : prospects?.sendProspectUncheckedText
            }
            state={prospects?.sendProspectChecked}
            disabled={prospects.incompleteProspect}
            onChangeState={(): void => {
              prospects?.handleSendProspectChange(
                !prospects?.sendProspectChecked,
                match.params.email,
              )
            }}
          />
          <CircleCheckbox
            name={
              prospects?.activateManeuverChecked
                ? prospects?.activateManeuverOption.text
                : 'Maneuver Inactive'
            }
            state={prospects?.activateManeuverChecked}
            disabled={!prospects?.activateManeuverOption.enabled || prospects.incompleteProspect}
            onChangeState={(): void => {
              prospects?.handleActivateManeuverChange(
                !prospects?.activateManeuverChecked,
                match.params.email,
              )
            }}
          />
          <CircleCheckbox
            name={prospects?.prospectDNCText}
            state={prospects?.prospectDNCChecked}
            disabled={prospects.incompleteProspect}
            onChangeState={(): void => {
              prospects?.handleProspectDNCChange(!prospects?.prospectDNCChecked, match.params.email)
            }}
            type="times"
          />
        </div>
        <div className="node-section">
          <Divider />
          <Notes prospects={prospects} />
          <Divider />
        </div>
        <EmailTemplatesModal
          open={openTemplateModal}
          currentType={currentType}
          handleClose={handleCloseTemplateModal}
          prospects={prospects}
          history={history}
          match={match}
          location={location}
        />
      </div>
    )
  }

  return null
}

export default inject('prospects')(withRouter(observer(Actions)))
